/** Email Templates navigation routes (mirror `routes/index.tsx`). */

const EMAIL_TEMPLATES_BASE = '/email-templates'

export const EMAIL_TEMPLATES_ROUTES = {
  add: `${EMAIL_TEMPLATES_BASE}/add`,
  edit: (templateId: number | string): string =>
    `${EMAIL_TEMPLATES_BASE}/edit/${templateId}`,
} as const
